<script lang="ts">
	//Design system components
	import { AdvancedCardV2, SliderV2 } from '@Shelly/shelly-design-system';
	//Helpers
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	import { translateTemplateTitle } from 'src/helpers/xt1_helpers/template_helpers';
	import { gen2Request } from 'src/services/gen_2_http_reqs';
	//Types
	import type { Device } from 'src/types/Device';
	import type { SettingRequest } from 'src/types/requests/settings/setting';
	import type { VCInterfaceStatus } from 'src/types/VirtualComponents';

	export let device: Device, status: VCInterfaceStatus;

	let value: number = 0;
	let waitForResponse: boolean = false;
	let valueBeforeSend: number = null;
	let min = Number(status.config?.min ?? 0);
	let max = Number(status.config?.max ?? 100);

	const configUI = status.config?.meta?.ui || {};

	$: if (status) {
		value =
			valueBeforeSend !== null
				? valueBeforeSend
				: (status?.rawValue ?? status.config?.default_value ?? 0);
		if (!waitForResponse && valueBeforeSend !== null && value == valueBeforeSend) {
			valueBeforeSend = null;
		}
	}

	const changePosition = async (value: number) => {
		waitForResponse = true;
		valueBeforeSend = value;
		const res: SettingRequest = await gen2Request(device, 'Number.set', {
			id: status.id,
			value,
		});
		if (!res?.isok) {
			onSettingsResponse(res, device);
		}
		waitForResponse = false;
	};

	const a11yProps = {
		ariaLabel: translateTemplateTitle(status.name),
		ariaLabelValue:
			translateTemplateTitle(status.name) +
			' ' +
			(value || 0) +
			(configUI?.unit ? ' ' + configUI.unit : ''),
		role: 'slider',
		'aria-valuemin': min,
		'aria-valuemax': max,
		'aria-valuenow': value || 0,
		'aria-live': 'polite',
	};
</script>

<AdvancedCardV2 title="" class="mb-s">
	<div slot="main" class="d-flex flex-direction-column width-full">
		<SliderV2
			id="slider-qbv03x5"
			{a11yProps}
			type="simple"
			class="mt-xs"
			{value}
			{min}
			{max}
			isLoading={waitForResponse}
			step={Number(configUI?.step || 1)}
			unit={' ' + (configUI.unit || '')}
			title={translateTemplateTitle(status.name)}
			on:value_change={(e) => {
				changePosition(e.detail.value);
			}}
		/>
	</div>
</AdvancedCardV2>
